// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

/**
 * @class M.Model.ProductDetails.PhotoView
 *
 * Model for a product view (photo) option on the product details page.
 *  "id": 1,
 *  "code": "001",
 *  "description": "Front"
 */
M.Model.ProductDetails.PhotoView = Backbone.Model.extend();
